export class RegisterInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "billingToken",
            "baseName": "billingToken",
            "type": "RegisterInputBillingToken",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RegisterInput.attributeTypeMap;
    }
    constructor() {
    }
}
